module.exports = __webpack_public_path__ + "img/rpn.59f5bfa4.svg";